import React from 'react';
import { Modal, Button } from 'antd';
import './CancelSubscription.scss';

const CancelSubscription = ({
    visible,
    onClose,
    confirmCancellation,
    cancelLoader,
    openPricingPlansModal
}) => {
    return (
        <Modal
            centered
            closable
            maskClosable={false}
            visible={visible}
            onCancel={onClose}
            footer={null}
            className="cancel-subscription-modal"
            destroyOnClose={true}
            width={480}>

            <div className="sub-cancel-content">
                <div className="manrope f-20 w-500 black-085 lh-28 mb-24">
                    Are you sure you want to cancel?
                </div>

                <div className="manrope f-14 w-500 black-085 lh-22 mb-24">
                    You can always switch your subscription, or choose a one-time bundle with the credits you need.
                </div>
                <div className="justify-in-end cancel-actions">
                    <Button
                        className="skip-button"
                        onClick={() => openPricingPlansModal("subscriptions")}>
                        View pricing & plans
                    </Button>
                    <Button
                        loading={cancelLoader}
                        className="schedule-button"
                        onClick={confirmCancellation}>
                        Confirm cancellation
                    </Button>
                </div>

            </div>
        </Modal>
    );
};

export default CancelSubscription;

